// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import PayerController from "./payer_controller";
application.register("payer", PayerController);

import FeeInstallmentController from "./fee_installment_controller";
application.register("fee-installment", FeeInstallmentController);

import HighlightController from "./highlight_controller";
application.register("highlight", HighlightController);

import InlineEditController from "./inline_edit_controller";
application.register("inline-edit", InlineEditController);

import LessonFormController from "./lesson_form_controller";
application.register("lesson-form", LessonFormController);

import HolidaysController from "./holidays_controller";
application.register("holidays", HolidaysController);

import LateFeePolicyController from "./late_fee_policy_controller";
application.register("late-fee-policy", LateFeePolicyController);

import DailyMessagesController from "./daily_messages_controller";
application.register("daily-messages", DailyMessagesController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import FilterController from "./filter_controller";
application.register("filter", FilterController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import SchoolTextPreviewController from "./school_text_preview_controller";
application.register("school-text-preview", SchoolTextPreviewController);

import IframeFitController from "./iframe_fit_controller";
application.register("iframe-fit", IframeFitController);

import VariableChipsController from "./variable_chips_controller";
application.register("variable-chips", VariableChipsController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import SlotHighlightController from "./slot_highlight_controller";
application.register("slot-highlight", SlotHighlightController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);
